import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, ShieldCheckIcon } from 'lucide-react';
const clients = [{
  name: 'Family Service Foundation, Inc.',
  location: 'Landover, MD',
  logo: 'https://cdn.magicpatterns.com/uploads/cuQftzCN5nQMftQCU7z5rL/image.png'
}, {
  name: 'VisualEyes',
  location: 'Clinton, MD',
  logo: 'https://cdn.magicpatterns.com/uploads/bMe4DiSJaALuUWE7JSDHDf/VisualEyesMain-Visual-Source-300x234.png'
}, {
  name: 'Embassy of Uganda',
  location: 'Washington, DC',
  logo: 'https://cdn.magicpatterns.com/uploads/ghwRD6jEnv8BpzjdVCah13/washingtonlogoenhanced_0.png'
}, {
  name: 'MHS',
  location: 'Maryland, USA',
  logo: 'https://cdn.magicpatterns.com/uploads/hxbQxuEQiLWBcbXiaAXiez/MHS-Logo-Blue.svg'
}, {
  name: 'Jarmachi Plastic Surgery',
  location: 'Maryland, USA',
  logo: 'https://cdn.magicpatterns.com/uploads/m9DaLJvQLAotYis9eZ5H5x/Logo-removebg-preview-1.webp'
}, {
  name: 'Summit Medical Group',
  location: 'Maryland, USA',
  logo: 'https://cdn.magicpatterns.com/uploads/kZFqDDXtxMiU1DGq95GYCG/SMG_LOOG.png'
}];
export function CustomerTrust() {
  return <section className="py-20 bg-white border-t border-slate-100" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-49">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-accent/10 text-accent text-sm font-bold mb-6" data-id="element-50">
            <ShieldCheckIcon className="w-4 h-4 mr-2" data-id="element-51" />
            Trusted by Industry Leaders
          </div>
          <p className="text-sm font-bold uppercase tracking-widest text-primary mb-3" data-id="element-52">
            Trusted Partnerships
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-53">
            Organizations That Trust Ambient Telecom
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-54">
            From government institutions to growing businesses, we deliver
            reliable telecom solutions that reduce costs and improve
            connectivity.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5" data-id="element-55">
          {clients.map((client, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="bg-slate-50 border border-slate-200 rounded-2xl p-6 flex flex-col items-center justify-center text-center min-h-[140px]" data-id="element-56">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4 overflow-hidden" data-id="element-57">
                {client.logo ? <img src={client.logo} alt={client.name} className="w-full h-full object-contain p-1" data-id="element-58" /> : <BuildingIcon className="w-6 h-6 text-primary" data-id="element-59" />}
              </div>
              <h3 className="text-sm font-bold text-slate-900 leading-tight" data-id="element-60">
                {client.name}
              </h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-61">{client.location}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}